import { Slide01Title } from './Slide01Title'
import { Slide02ExecSummary } from './Slide02ExecSummary'
import { Slide03Background } from './Slide03Background'
import { Slide04Approach } from './Slide04Approach'
import { Slide05Benefits } from './Slide05Benefits'
import { Slide06Timeline } from './Slide06Timeline'
import { Slide07Scope } from './Slide07Scope'
import { Slide08Scale } from './Slide08Scale'
import { Slide08Expansion } from './Slide08Expansion'
import { Slide09Metrics } from './Slide09Metrics'
import { Slide10Contacts } from './Slide10Contacts'
import { Slide11Actions } from './Slide11Actions'
import { Slide13Optimization } from './Slide13Optimization'
import { Slide14Channels } from './Slide14Channels'
import { Slide15Timeline } from './Slide15Timeline'
import { Slide16NextSteps } from './Slide16NextSteps'
import { Slide17Closing } from './Slide17Closing'

export const slides = [
  Slide01Title,
  Slide02ExecSummary,
  Slide03Background,
  Slide04Approach,
  Slide05Benefits,
  Slide06Timeline,
  Slide07Scope,
  Slide08Scale,
  Slide08Expansion,
  Slide09Metrics,
  Slide10Contacts,
  Slide11Actions,
  Slide13Optimization,
  Slide14Channels,
  Slide15Timeline,
  Slide16NextSteps,
  Slide17Closing,
]

export const slideTitles: { section: string; title: string }[] = [
  { section: 'Cover', title: 'Amoxil Snakker Campaign Proposal' },
  { section: '02', title: 'Executive Summary' },
  { section: '03', title: 'Current Situation' },
  { section: '04', title: 'Strategic Opportunity' },
  { section: '05', title: 'Proposed Campaign Model' },
  { section: '06', title: 'What Is a Teaser?' },
  { section: '07', title: 'What Is a Trailer / Microsite?' },
  { section: '08', title: 'Master-Based Production Logic' },
  { section: '09', title: 'Asset Lifespan Recommendation' },
  { section: '10', title: '6-Month Proposal' },
  { section: '11', title: '12-Month Proposal' },
  { section: '12', title: 'Why 12 Months Is Recommended' },
  { section: '13', title: 'Monitoring & Optimization' },
  { section: '14', title: 'Channel-Agnostic Deployment' },
  { section: '15', title: 'Timeline & Approvals' },
  { section: '16', title: 'Next Steps' },
  { section: '17', title: 'Closing Recommendation' },
]
